const DEFAULT_SOP_LABEL = 'Create Training';
const DEFAULT_QRG_LABEL = 'Cheat Sheet';
function trimEnv(value) {
    return (value ?? '').trim();
}
/** User-visible name for the SOP template (`REACT_APP_PRODUCT_LABEL_SOP`). */
export function getProductLabelSop() {
    const fromEnv = trimEnv(process.env.REACT_APP_PRODUCT_LABEL_SOP);
    return fromEnv.length > 0 ? fromEnv : DEFAULT_SOP_LABEL;
}
/** User-visible name for the QRG template (`REACT_APP_PRODUCT_LABEL_QRG`). */
export function getProductLabelQrg() {
    const fromEnv = trimEnv(process.env.REACT_APP_PRODUCT_LABEL_QRG);
    return fromEnv.length > 0 ? fromEnv : DEFAULT_QRG_LABEL;
}
/** Tab and picker labels for document templates; SOP/QRG use product env labels. */
export function getTemplateDisplayLabel(template) {
    switch (template) {
        case 'sop':
            return getProductLabelSop();
        case 'qrg':
            return getProductLabelQrg();
        case 'narrative':
            return 'Guide';
        case 'script':
            return 'Script';
        case 'annotated_walkthrough':
            return 'Walkthrough';
        case 'troubleshooting':
            return 'Troubleshoot';
        case 'quiz':
            return 'Quiz';
        case 'changelog':
            return 'Change Log';
        default: {
            const _exhaustive = template;
            return _exhaustive;
        }
    }
}
